module.exports = __webpack_public_path__ + "static/media/emailLogo.cad8248c.svg";